import { httpGet } from './utils';

const api = {
  retrieveCurrent: httpGet,
};

export default api;
